import auth from "@/middlewares/auth";
import guest from "@/middlewares/guest";
import { userRoutes } from "@/routes/users/userRoutes";
import { ticketRoutes } from "@/routes/users/ticketRoutes";
import { otherRoutes } from "@/routes/setting/otherRoutes";
import { customerRoutes } from "@/routes/customer/customerRoutes";

let routes = [
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "auth" */ '../views/auth/Login'),
    name: 'login',
    meta: {
      middleware: [
        guest
      ]
    }
  },
  {
    path: '/',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboard'),
    name: 'dashboard',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/403',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/errorPages/403.vue'),
    name: '403',
  },
]

routes.push(...userRoutes);
routes.push(...ticketRoutes);
routes.push(...otherRoutes);
routes.push(...customerRoutes);

export default routes;
